import React from 'react';

import { useStyles } from '../styles';

export function AuthenticatingLoader(): JSX.Element {
  const s = useStyles();

  return (
    <div className={s.formContent}>
      <div className={s.authenticatingContainer}>
        <div className={s.spinner} />
        <p className={s.authenticatingTitle}>Authenticating...</p>
        <p className={s.authenticatingSubtitle}>Please wait while we verify your credentials</p>
      </div>
    </div>
  );
}

export default AuthenticatingLoader;
